import { Paper } from '@mantine/core';
import { Navigate, Outlet } from 'react-router-dom';
import LandingGradientBackground from '../components/LandingGradientBackground/LandingGradientBackground';
import styles from './UnauthenticatedAppLayout.module.css';
import { useAuthSessionState } from '@/app/AuthSessionState';
import logo from '@/assets/full-white-logo.webp';

export const UnauthenticatedAppLayout = () => {
  const authState = useAuthSessionState();

  switch (authState.status) {
    case 'unauthenticated': {
      return (
        <LandingGradientBackground>
          <div className={styles.container}>
            <div className={styles.authHeader}>
              <a href='https://practist.io' style={{ textDecoration: 'none' }}>
                <img
                  src={logo}
                  alt='Practist Logo'
                  className={styles.authLogo}
                  style={{ cursor: 'pointer' }}
                />
              </a>
            </div>
            <Paper className={styles.authBody} shadow='sm' radius='md'>
              <Outlet />
            </Paper>
          </div>
        </LandingGradientBackground>
      );
    }
    case 'unknown':
      return null;
    case 'authenticated':
      return <Navigate to='/matters' replace />;
  }
};

export default UnauthenticatedAppLayout;
